module.exports = __webpack_public_path__ + "static/media/vacuderma-logo.ed8215b0.jpg";